<div class="eventq-talkdown-group">
  <div class="eventq-talkdown-group__speaker">{{ speakerName() }}</div>
  <ul class="eventq-talkdown-group__cameras">
    @for (label of cameraLabels(); track label) {
      <li class="eventq-talkdown-group__camera">{{ label }}</li>
    } @empty {
      <li class="eventq-talkdown-group__camera eventq-talkdown-group__camera--empty">
        No Camera Linked
      </li>
    }
  </ul>
  <button type="button" class="eventq-talkdown-group__activate" (click)="activate.emit()">
    Activate Talkdown
  </button>
</div>
